import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.match(/session_id=([^&]+)/)?.[1];
    if (!sessionId) { navigate("/admin"); return; }
    api.post("/auth/google/session", { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        if (data?.token) localStorage.setItem("wouffa_admin_token", data.token);
        navigate(data?.role === "admin" ? "/admin" : "/", { replace: true });
      })
      .catch(() => navigate("/admin", { replace: true }));
  }, [location.hash, navigate]);
  return <div className="min-h-screen bg-[#0a0908]" />;
};
